import axios from 'axios'
import * as types from '../mutation-types'

// state
export const state = {
  towns: [],
  town: null,
  filteredTownsData: [],
  townTotalItems: null
}

// mutations
export const mutations = {
  [types.SET_TOWNS] (state, payload) {
    payload.data ? state.towns = payload.data : state.towns = payload
    payload.data ? state.townTotalItems = payload.total : state.townTotalItems = null
  },
  [types.SET_TOWN] (state, town) {
    state.town = town
  },
  [types.FETCH_TOWN_FAILURE] (state) {
    state.town = null
  },
  filterTowns (state, data) {
    state.filteredTownsData = data
  }
}

// actions
export const actions = {
  async fetchTowns ({ commit }, payload) {
    try {
      const { data } = await axios.get('/towns?include=district', {
        params: payload ? payload.query : ''
      })
      commit(types.SET_TOWNS, data)
    } catch (e) {
      console.log(e)
    }
  },
  async fetchTown ({ commit }, town) {
    try {
      const { data } = await axios.get(`/towns/${town.id}`)

      commit(types.SET_TOWN, { town: data })
    } catch (e) {
      commit(types.FETCH_TOWN_FAILURE)
    }
  },

  async createTown (context, town) {
    try {
      await axios.post('/api/towns', town)
      context.dispatch('fetchTowns')
    } catch (e) {
      console.log(e)
    }
  },

  async updateTown (context, town) {
    try {
      await axios.put(`/api/towns/${town.id}`, town)
      context.dispatch('fetchTowns')
    } catch (e) { }
  },

  async deleteTown (context, town) {
    try {
      await axios.delete(`/api/towns/${town.id}`)
      context.dispatch('fetchTowns')
    } catch (e) { }
  }
}

// getters
export const getters = {
  towns: state => state.towns,
  getTownByDistrictId: (state) => (id) => {
    return state.towns.filter(town => town.district_id === id)
  },
  filteredTownsData: state => state.filteredTownsData,
  townTotalItems: state => state.townTotalItems
}



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/town.js